// Identité produit centralisée.
// Le nom commercial est Linea (charte d'août 2026, décision de Louka du 12/10/2026) : TOUTE
// mention du produit dans l'UI, les emails et les livrables passe par ce module.
// Sous-plan 5 : une SPA par app, la marque vient du build (NEXT_PUBLIC_PRODUCT_NAME,
// NEXT_PUBLIC_SIDEBAR_BRAND_NAME) ; sans elles, la marque de la compta.
function depuisEnv(valeur: string | undefined, repli: string): string {
  const v = typeof valeur === "string" ? valeur.trim() : "";
  return v || repli;
}
export const PRODUCT_NAME = depuisEnv(
  process.env.NEXT_PUBLIC_PRODUCT_NAME,
  "Linea"
);

// Libellé affiché à côté du symbole de la marque (rail, connexion, onboarding) :
// Linea, le nom de la charte d'août 2026 (décision de Louka du 12/10/2026).
export const SIDEBAR_BRAND_NAME = depuisEnv(
  process.env.NEXT_PUBLIC_SIDEBAR_BRAND_NAME,
  "Linea"
);

// Émetteur des emails transactionnels (consommé par config.getSupportEmailAddress ;
// l'adresse réelle sera branchée avec le domaine du produit lors de la bascule Brevo).
export const PRODUCT_EMAIL_FROM_NAME = `Équipe ${PRODUCT_NAME}`;
export const PRODUCT_SUPPORT_EMAIL_FALLBACK = "support@appcompta.local";

// Préfixe standard des sujets d'emails — un seul endroit à changer pour toute la flotte.
export function emailSubject(subject: string): string {
  return `[${PRODUCT_NAME}] ${subject}`;
}

// Sous-plan 10, lot B : le sous-menu « Help » du menu utilisateur de Dust (docs.dust.tt, communaute
// Slack, agent @help) ne concerne que Dust.tt ; l'agent help n'est visible d'aucun role.
export const MENU_AIDE_DUST = false;

// Sous-plan 10, lot E1 : la fiche d'un assistant ne montre pas son modele ; le modele est choisi par
// le superadmin dans la fiche du membre (lot E3), jamais expose dans le chat.
export const FICHE_ASSISTANT_AVEC_MODELE = false;

// Lot E1b : la page de creation d'un assistant ne montre ni le modele (choisi par le superadmin) ni
// la gestion des credits ; la fiche ne montre pas le bandeau email de Dust.
export const PAGE_CREATION_AVEC_MODELE = false;
export const PAGE_CREATION_AVEC_CREDITS = false;

// 02/10 (decision de Louka) : la page des agents ne montre le modele a personne, administrateurs
// compris (ni colonne Modele, ni filtre « Models », ni changement de modele groupe) ; le superadmin
// choisit les modeles dans l'app.
export const PAGE_AGENTS_AVEC_MODELE = false;
export const FICHE_ASSISTANT_AVEC_EMAIL = false;

// 01/10 (remarques de Louka) : la fiche d'un assistant ne montre ni cout ni credits (onglet
// Statistiques reduit aux usages : periode, membres actifs, messages) ; le « Sidekick » du
// constructeur d'assistant porte le nom de l'assistant de l'app (NEXT_PUBLIC_SIDEKICK_NAME).
export const FICHE_ASSISTANT_AVEC_CREDITS = false;

// 30/10 (remarque de Louka : « on voit encore parfois les icones de Dust ») : les competences
// fournies d'office ne portent pas le badge au logo de Dust.
export const BADGE_COMPETENCES_FOURNIES = false;

// 31/10 (meme remarque) : l'avatar par defaut de Dust (chargement de la barre de saisie, competences
// fournies, assistant @dust) est celui de l'assistant de l'app, servi par sa SPA
// (static/marques/<marque>/assistant.png) ; sans marque (front-api, compta), un emoji neutre.
export const AVATAR_NEUTRE =
  "https://dust.tt/static/emojis/bg-blue-400/robot_face/1f916";
export function avatarAssistantApp(
  baseSpa: string | undefined,
  marque: string | undefined
): string {
  const base = typeof baseSpa === "string" ? baseSpa.trim() : "";
  if (!/^https:\/\/[^\s]+$/.test(base) || !/^[a-z0-9-]+$/.test(marque ?? "")) {
    return AVATAR_NEUTRE;
  }
  return `${base.replace(/\/+$/, "")}/static/marques/${marque}/assistant.png`;
}
export const AVATAR_ASSISTANT_APP = avatarAssistantApp(
  process.env.NEXT_PUBLIC_DUST_APP_URL,
  process.env.NEXT_PUBLIC_MARQUE
);
export const SIDEKICK_NAME = depuisEnv(
  process.env.NEXT_PUBLIC_SIDEKICK_NAME,
  "Sidekick"
);
